/* Kick Frame — welkomstkorting: pop-up "10% korting op je eerste bestelling" voor nieuwsbrief-inschrijvers.
   Vervangt de oude nieuwsbrief-pop-up uit kickframe.js (die wordt hier stilgezet via zijn localStorage-sleutel).
   Inschrijven gaat via de bestaande Klaviyo-afhandeling in kickframe.js (formulier met data-klaviyo-list);
   na succes ('kf:newsletter-subscribed') tonen we de code WELKOM10 met een knop die hem direct toepast.
   Kortingscode in Shopify: WELKOM10, 10% op A3-posters zonder lijst (geen cadeaubon), eenmalig per klant, niet te combineren met andere kortingen.
   Op mobiel eerst alleen een smalle balk onderin; de pop-up opent pas als iemand daarop tikt. */
(function () {
  var CODE = 'WELKOM10';
  var KEY = 'kf-welcome-seen';
  var nl = /^nl/i.test(document.documentElement.lang || '');

  // oude pop-up uit kickframe.js niet meer tonen (dit script laadt vóór kickframe.js)
  try { localStorage.setItem('kf-popup-seen', '1'); } catch (e) {}

  var seen = true;
  try { seen = Boolean(localStorage.getItem(KEY)); } catch (e) {}
  if (seen || (window.Shopify && window.Shopify.designMode)) return;
  if (/template-cart/.test(document.body ? document.body.className : '')) return;

  var T = nl ? {
    eyebrow: 'Welkom bij Kick Frame',
    title: '10% korting op je eerste A3-poster',
    text: 'Schrijf je in voor de nieuwsbrief en krijg direct 10% korting op je eerste A3-poster. Plus als eerste nieuwe ontwerpen zien.',
    label: 'E-mailadres', placeholder: 'jij@email.nl', button: 'Geef mij 10% korting',
    note: 'Geen spam. Met één klik uitschrijven.',
    thanks: 'Bedankt! Je bent ingeschreven.',
    doneTitle: 'Je kortingscode',
    doneText: '10% korting op je eerste A3-poster (zonder lijst).',
    apply: 'Korting gebruiken', copy: 'Kopieer code', copied: 'Gekopieerd!', close: 'Sluiten',
    bar: '10% korting op je eerste A3-poster', barButton: 'Claim'
  } : {
    eyebrow: 'Welcome to Kick Frame',
    title: '10% off your first A3 poster',
    text: 'Join the newsletter and get 10% off your first A3 poster. Plus be the first to see new designs.',
    label: 'Email address', placeholder: 'you@email.com', button: 'Get my 10% off',
    note: 'No spam. Unsubscribe with one click.',
    thanks: "Thanks! You're subscribed.",
    doneTitle: 'Your discount code',
    doneText: '10% off your first A3 poster (unframed).',
    apply: 'Use my discount', copy: 'Copy code', copied: 'Copied!', close: 'Close',
    bar: '10% off your first A3 poster', barButton: 'Claim'
  };

  var mobile = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;

  var css = ''
    + '.kf-welcome-code{display:flex;align-items:center;justify-content:center;gap:.6rem;margin:1rem 0;padding:.9rem 1rem;'
    + 'border:2px dashed var(--gold,#d6b25e);border-radius:12px;font:700 1.5rem/1 Inter,system-ui,sans-serif;letter-spacing:.18em;color:var(--gold,#d6b25e)}'
    + '.kf-welcome-actions{display:flex;flex-wrap:wrap;gap:.6rem}'
    + '.kf-welcome-actions .button{flex:1 1 auto}'
    // smalle balk op mobiel, boven de vaste "In winkelwagen"-balk
    + '.kf-welcome-bar{position:fixed;left:12px;right:12px;bottom:calc(84px + env(safe-area-inset-bottom,0px));z-index:60;display:flex;align-items:center;gap:.5rem;'
    + 'padding:.55rem .5rem .55rem .9rem;border-radius:999px;background:#111;color:#fff;box-shadow:0 6px 24px rgba(0,0,0,.25);'
    + 'font:600 .85rem/1.2 Inter,system-ui,sans-serif;transform:translateY(160%);transition:transform .3s ease}'
    + '.kf-welcome-bar.is-visible{transform:none}'
    + '.kf-welcome-bar span{flex:1 1 auto}'
    + '.kf-welcome-bar .kf-wb-claim{flex:none;border:0;border-radius:999px;padding:.45rem .9rem;background:var(--gold,#d6b25e);color:#111;font:700 .8rem/1 Inter,system-ui,sans-serif;cursor:pointer}'
    + '.kf-welcome-bar .kf-wb-close{flex:none;border:0;background:none;color:#fff;opacity:.7;font-size:1.3rem;line-height:1;padding:.2rem .4rem;cursor:pointer}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function remember() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }

  // niet tegelijk met de cookiemelding van Shopify: wachten tot die weg is
  // (offsetParent is altijd null bij een fixed element, dus kijken naar de afmetingen)
  function cookieBannerOpen() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var r = b.getBoundingClientRect(), s = getComputedStyle(b);
    return r.width > 0 && r.height > 0 && s.visibility !== 'hidden' && s.display !== 'none';
  }
  function showWhenFree() {
    if (cookieBannerOpen()) { window.setTimeout(showWhenFree, 700); return; }
    window.setTimeout(mobile ? showBar : show, 400);
  }
  // niet meteen bij binnenkomst: na 20 s, of eerder als iemand de halve pagina scrolt (min. 8 s)
  var started = Date.now(), fired = false;
  function trigger() {
    if (fired) return;
    fired = true;
    window.removeEventListener('scroll', onScroll);
    showWhenFree();
  }
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h > 0.5 && Date.now() - started > 8000) trigger();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  // Productpagina: geen timer. Clarity (4-11) liet zien dat bezoekers uit Google Shopping bovenaan
  // formaat/lijst vergelijken; de balk viel dan over de keuzes en de koopknop. Daar alleen na scrollen.
  if (!document.querySelector('[data-product-form]')) window.setTimeout(trigger, 20000);

  function showBar() {
    var bar = document.createElement('div');
    bar.className = 'kf-welcome-bar';
    bar.innerHTML = '<span>' + esc(T.bar) + '</span>'
      + '<button type="button" class="kf-wb-claim">' + esc(T.barButton) + '</button>'
      + '<button type="button" class="kf-wb-close" aria-label="' + esc(T.close) + '">&times;</button>';
    // alleen op productpagina's staat de vaste "In winkelwagen"-balk onderin
    if (!document.querySelector('.sticky-buy')) bar.style.bottom = 'calc(12px + env(safe-area-inset-bottom,0px))';
    document.body.appendChild(bar);
    function hide() {
      bar.classList.remove('is-visible');
      window.setTimeout(function () { bar.remove(); }, 300);
    }
    bar.querySelector('.kf-wb-claim').addEventListener('click', function () { hide(); show(); });
    bar.querySelector('.kf-wb-close').addEventListener('click', function () { remember(); hide(); });
    window.requestAnimationFrame(function () { bar.classList.add('is-visible'); });
  }

  function show() {
    var overlay = document.createElement('div');
    overlay.className = 'popup-overlay';
    overlay.innerHTML =
      '<div class="popup" role="dialog" aria-modal="true" aria-labelledby="kf-welcome-title">'
      + '<button type="button" class="popup-close" aria-label="' + esc(T.close) + '">&times;</button>'
      + '<div data-kf-welcome-step="form">'
      + '<p class="eyebrow eyebrow--accent">' + esc(T.eyebrow) + '</p>'
      + '<h2 id="kf-welcome-title">' + esc(T.title) + '</h2>'
      + '<p>' + esc(T.text) + '</p>'
      + '<form class="newsletter" data-klaviyo-list="Wakke6" data-klaviyo-company="UcTc4g" data-klaviyo-form="' + esc(T.thanks) + '">'
      + '<label class="visually-hidden" for="kf-welcome-email">' + esc(T.label) + '</label>'
      + '<input id="kf-welcome-email" type="email" name="email" placeholder="' + esc(T.placeholder) + '" required autocomplete="email">'
      + '<button class="button" type="submit">' + esc(T.button) + '</button>'
      + '</form>'
      + '<p class="form-note">' + esc(T.note) + '</p>'
      + '</div>'
      + '<div data-kf-welcome-step="done" hidden>'
      + '<p class="eyebrow eyebrow--accent">' + esc(T.eyebrow) + '</p>'
      + '<h2>' + esc(T.doneTitle) + '</h2>'
      + '<div class="kf-welcome-code">' + CODE + '</div>'
      + '<p>' + esc(T.doneText) + '</p>'
      + '<div class="kf-welcome-actions">'
      + '<a class="button" data-kf-welcome-apply href="#">' + esc(T.apply) + '</a>'
      + '<button type="button" class="button button--ghost" data-kf-welcome-copy>' + esc(T.copy) + '</button>'
      + '</div>'
      + '</div>'
      + '</div>';
    document.body.appendChild(overlay);

    function close() {
      overlay.classList.remove('is-visible');
      remember();
      window.setTimeout(function () { overlay.remove(); }, 250);
    }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.popup-close').addEventListener('click', close);
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
    });

    // korting direct op de winkelwagen zetten en terug naar dezelfde pagina
    overlay.querySelector('[data-kf-welcome-apply]').href = '/discount/' + CODE + '?redirect=' + encodeURIComponent(location.pathname + location.search);
    overlay.querySelector('[data-kf-welcome-apply]').addEventListener('click', remember);
    overlay.querySelector('[data-kf-welcome-copy]').addEventListener('click', function () {
      var btn = this;
      try { navigator.clipboard.writeText(CODE); } catch (e) {}
      btn.textContent = T.copied;
    });

    // na geslaagde inschrijving (kickframe.js) de code tonen
    document.addEventListener('kf:newsletter-subscribed', function () {
      remember();
      overlay.querySelector('[data-kf-welcome-step="form"]').hidden = true;
      overlay.querySelector('[data-kf-welcome-step="done"]').hidden = false;
    }, { once: true });

    window.requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
  }
})();
